import React from 'react';
import {
    Button,
    Grid,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Add as AddIcon } from '@material-ui/icons';
import { Link } from 'react-router-dom';
import { t } from '../../../../../core/i18n';
import { useList } from '../../../../../core/hooks/useList';
import Progress from '../../../../shared/progress/Progress';
import {
    history,
    route,
    ROUTE_ADMINISTRATION_RECURRING_ADD,
    ROUTE_ADMINISTRATION_RECURRING_EDIT,
} from '../../../../../core/routing/routing';
import Alert from '@material-ui/lab/Alert';
import {
    deleteRecurring,
    getRecurrings,
} from '../../../../../core/modules/accounting/recurring/actions';
import { Collections } from 'core/networking/firebase';
import BaseMaterialTable from 'components/shared/table/BaseMaterialTable';
import { useSelector } from 'react-redux';

const styles = () => ({
    addBtn: {
        marginBottom: 20,
    }
});

const RecurringOverviewScene = ({ classes }) => {
    const workspaceId = useSelector(state => state.app.workspace);

    const { items, isLoading, error, refreshList, canSoftDelete, canDelete, canEdit } = useList(
        getRecurrings, Collections.recurring
    );

    const headCells = [
        {
            id: 'name',
            title: t('recurring.fields.name'),
            field: `name`,
            render: rowData => rowData.name,
        }
    ]

    const menuActions = [
        {
            action: 'edit',
            to: ROUTE_ADMINISTRATION_RECURRING_EDIT,
            routeParam: 'id',
            routeParamExtra: { workspaceId: workspaceId }
        },
        {
            action: 'deleteForever',
        },
    ]

    const handleRowClick = (event, rowData) => {
        history.push(route(ROUTE_ADMINISTRATION_RECURRING_EDIT, { workspaceId, id: rowData.id }))
    };

    if (isLoading) {
        return <Progress isLoading={isLoading} />;
    } else {
        return (
            <>
                {error && <Alert severity="error">{error}</Alert>}
                {items && (
                    <>
                        <Grid
                            container
                            direction="row"
                            justify="flex-end"
                            alignItems="center"
                            className={classes.addBtn}
                        >
                            <Button
                                component={Link}
                                variant="contained"
                                color="primary"
                                startIcon={<AddIcon />}
                                to={route(ROUTE_ADMINISTRATION_RECURRING_ADD, { workspaceId })}>
                                {t('recurring.add')}
                            </Button>
                        </Grid>
                        <BaseMaterialTable
                            title={t('recurring.title')}
                            headCells={headCells}
                            items={items}
                            canEdit={canEdit}
                            canSoftDelete={canSoftDelete}
                            canDelete={canDelete}
                            refreshList={refreshList}
                            menuActions={menuActions}
                            deleteItemFunc={deleteRecurring}
                            collection={Collections.recurring}
                            handleRowClick={handleRowClick}
                        />
                    </>
                )}
            </>
        );
    }
};

export default withStyles(styles)(RecurringOverviewScene);
